import { useContext } from "react";

const useContextHook = (context) => {
    const contextValue = useContext(context);
    return contextValue;
};

export default useContextHook;
